import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const propTypes = {
    html: PropTypes.string.isRequired
};

/**
 * @param {HTMLScriptElement[]} scripts
 * @param {HTMLElement} container
 */
const loadScriptsSequentially = (scripts, container) => {
    if (!scripts.length) { return; }
    const [ scriptEl, ...rest ] = scripts;
    const newScript = document.createElement('script');

    Array.from(scriptEl.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
    newScript.textContent = scriptEl.textContent;

    if (scriptEl.src) {
        newScript.onload = () => loadScriptsSequentially(rest, container);
        newScript.onerror = () => loadScriptsSequentially(rest, container);
    }

    container.appendChild(newScript);

    if (!scriptEl.src) {
        loadScriptsSequentially(rest, container);
    }
};

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CodeSnippet = (props) => {
    const [ html ] = useState(props.html || '<div></div>');

    const divRef = useRef(/** @type {HTMLDivElement | null} */ (null));

    useEffect(() => {
        if (!html || !divRef.current) { return; }

        const fragment = document.createRange().createContextualFragment(html);
        const scripts = Array.from(fragment.querySelectorAll('script'));
        scripts.forEach(s => s.remove());

        divRef.current.innerHTML = '';
        divRef.current.appendChild(fragment);
        loadScriptsSequentially(scripts, divRef.current);
    }, [html]);

    return (
        <div ref={divRef} />
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

CodeSnippet.propTypes = propTypes;

export default CodeSnippet;
